// extracted by mini-css-extract-plugin
export default {"container":"otp-step_container__2u09u","error-message":"otp-step_error-message__dDBzi"};